<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <oxd-text tag="h6" class="orangehrm-main-title">
        {{ $t('admin.add_contract_templates') }}
      </oxd-text>

      <oxd-divider />

      <oxd-form :loading="isLoading" @submit-valid="onSave">
        <oxd-form-row>
          <oxd-input-field
            v-model="contractTemplate.contractName"
            :label="$t('general.contract_name')"
            :rules="rules.contractName"
            required
          />
        </oxd-form-row>
        <oxd-form-row>
          <oxd-input-field
            v-model="contractTemplate.version"
            :label="$t('general.version')"
            :rules="rules.version"
            required
          />
        </oxd-form-row>
        <oxd-form-row>
          <oxd-input-field
            v-model="contractTemplate.description"
            type="textarea"
            :label="$t('general.description')"
            :rules="rules.description"
            required
          />
        </oxd-form-row>
        <oxd-form-row>
          <oxd-input-field
            v-model="contractTemplate.isActive"
            type="select"
            :options="statusOptions"
            :label="$t('general.status')"
          />
        </oxd-form-row>
        <oxd-form-row>
          <oxd-input-field
            v-model="contractTemplate.templateAttachment"
            type="file"
            accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            :label="$t('general.contract_file')"
            :button-label="$t('general.browse')"
            :rules="rules.templateAttachment"
            required
          />
          <oxd-text class="orangehrm-input-hint" tag="p">
            {{ $t('general.accepts_up_to_1mb') }}
          </oxd-text>
        </oxd-form-row>

        <oxd-divider />

        <oxd-form-actions>
          <required-text />
          <oxd-button
            display-type="ghost"
            :label="$t('general.cancel')"
            @click="onCancel"
          />
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script>
import {navigate} from '@ohrm/core/util/helper/navigation';
import {APIService} from '@/core/util/services/api.service';
import {
  required,
  validFileTypes,
  maxFileSize,
} from '@ohrm/core/util/validation/rules';

const initialData = {
  contractName: '',
  version: null,
  isActive: '',
  description: '',
  templateAttachment: null,
};

export default {
  props: {
    allowedFileTypes: {
      type: Array,
      required: true,
    },
    maxFileSize: {
      type: Number,
      required: true,
    },
  },

  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/pim/contract-templates',
    );
    return {
      http,
    };
  },

  data() {
    return {
      isLoading: false,
      contractTemplate: {...initialData},
      rules: {
        contractName: [required],
        version: [required],
        description: [required],
        templateAttachment: [
          required,
          validFileTypes(this.allowedFileTypes),
          maxFileSize(this.maxFileSize),
        ],
      },
      statusOptions: [
        {
          id: 1,
          param: 'active',
          label: this.$t('general.active'),
        },
        {
          id: 2,
          param: 'inactive',
          label: this.$t('general.inactive'),
        },
      ],
    };
  },
  methods: {
    onCancel() {
      navigate('/admin/contractTemplates');
    },
    onSave() {
      this.isLoading = true;
      this.http
        .create({
          ...this.contractTemplate,
          version: this.contractTemplate.version.toString(),
          isActive: this.contractTemplate.isActive.param === 'active',
        })
        .then(() => {
          return this.$toast.saveSuccess();
        })
        .then(() => {
          this.onCancel();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
